import React, { useState } from 'react'
import classNames from 'classnames'
import MainForm from '@toasttab/otl/src/components/Form/MainForm/MainForm'
import Button from '@toasttab/shared/src/components/atoms/Button/Button'
import Heading from '@toasttab/shared/src/components/molecules/Heading/Heading'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import { ContentfulFormCategory } from '@toasttab/shared/src/interfaces/ContentfulForms.d'
import { HiddenInfogramMobileFormProps } from './HiddenInfogram.d'

const HiddenInfogramMobileForm = ({
  ctaText,
  entryId,
  formFieldset,
  formRedirectUrl,
  marketoFormId,
  marketoProgramName
}: HiddenInfogramMobileFormProps) => {
  const [isFormVisible, setIsFormVisible] = useState(false)

  const handleClick = () => {
    setIsFormVisible(true)
  }
  const buttonClasses = classNames('!mb-0 font-semibold', {
    hidden: isFormVisible
  })

  const formClasses = classNames(
    'transition-all overflow-hidden !mb-0 [&>p]:mt-0 [&>p]:!mb-0 [&>p]:pb-0 [&>div]:mb-0 [&_form]:!mb-0 [&_button>div]:!mb-0',
    '[&_input]:!mb-0 [&_select]:!mb-0 font-sansPro text-base [&_select]:rounded-[4px]',
    {
      'max-h-screen': isFormVisible,
      'max-h-0': !isFormVisible
    }
  )
  return (
    <>
      <Heading
        classes='!mb-1 !mt-0 !text-[31px]'
        content={formFieldset.title}
        heading='h3'
      />
      <Typography
        as='p'
        classes='text-base text-secondary font-sansPro !mt-0 mb-4'
      >
        {formFieldset.description.description}
      </Typography>
      <Button classes={buttonClasses} onClick={handleClick} size='small'>
        {ctaText}
      </Button>
      <div
        className={formClasses}
        data-testid='HiddenInfogramMobileForm-formWrapper'
      >
        <MainForm
          buttonStyle='secondary-otl'
          buttonText={formFieldset.submitLabel}
          conversionType='OTL-DEMO-HEADLESS'
          entryId={entryId}
          formCategory={formFieldset as unknown as ContentfulFormCategory}
          formId={marketoFormId}
          formLayout='fullWidth'
          hideCoreFieldsOnProgressiveForm
          mds
          programName={marketoProgramName}
          redirectUrl={formRedirectUrl}
          typeHandle={formFieldset.__typename}
        />
      </div>
    </>
  )
}

export default HiddenInfogramMobileForm
